import React, { useContext } from 'react'
import { Link, useHistory, useParams } from 'react-router-dom';
import CrossGrey from "../../assets/images/CrossGrey.svg";
import lessThanIcon from "../../assets/images/lessThanIcon.svg";
import greaterThanIcon from "../../assets/images/greaterThanIcon.svg";
import ImageLoader from '../ImageLoader';
import dayjs from 'dayjs';
import { ChangeAnalysisContext } from '../../views/OnePageConsult';
import { calculateGroIndexScore } from '../../utlis/calculations';

const subtypes = [
	"front",
	"crown",
	"vertex",
	"occipital",
	"left",
	"right"
]


const GlobalImageCompare = ({ analyses, setReady }) => {
	const history = useHistory();

	const { patient_id, analysis_id, subType } = useParams();
	const analysis_id_int = parseInt(analysis_id);

	const { changeAnalysis } = useContext(ChangeAnalysisContext);

	return (
		<div style={{flexGrow: 1}}>
			<div className='absolute top-5 right-5'>
				<Link to={`/patient/${patient_id}/consult/${analysis_id}/global/${subType}/hair_thinning`}>
					<img src={CrossGrey} className='h-5 w-5' />
				</Link>
			</div>
			<div class="flex justify-center my-1">
				<div className='relative px-14 text-center font-bold text-lg font-sans tracking-wider text-text-15'>
				<button
					className="text-2xl focus:outline-none absolute left-5 top-0"
					style={{transform: 'translate(0%, -4%)'}}
					onClick={function () {
						// changeAnalysis(history, 'next', analysis_id_int, analyses);
					}}
				>
					<img src={lessThanIcon} className='w-8 h-8' />
				</button>
				 Hair Growth Tracking
				</div>
			
			</div>
			<div className='flex justify-center'>
				{subtypes.map((item, index) => {
					return <div key={index} className={`mt-1 text-center mx-2 font-normal text-base font-sans tracking-wider ${subType === item ? `opacity-80` : `opacity-40`} text-text-15 capitalize`}>
						<Link to={`/patient/${patient_id}/consult/${analysis_id}/compare/global/${item}`}>
							{item.replace(item[0], item[0].toUpperCase())}
						</Link>
					</div>
				})}
			</div>

			<div className='flex items-center justify-center'>
				<button
					className="text-2xl focus:outline-none"
					onClick={function () {
						changeAnalysis(history, 'prev', analysis_id_int, analyses);
					}}
				>
					<img src={lessThanIcon} className='w-14 h-14' />
				</button>
				<div className='grid justify-center gap-14 flex-grow grid-cols-3 px-10 mt-3 pb-3'>
					{analyses.map((analysis, index) => {
						if (index === analysis_id_int - 1 || index === analysis_id_int || index === analysis_id_int + 1) {
							return (
								<div
									className={`flex flex-col items-center justify-center px-4 ${analysis_id_int === 0 && index === 0 ? 'col-start-2' : ''}`}
								>
									<div className="text-center">
										{analysis?.images?.global?.raw && <div className='mb-10'><ImageLoader setReady={setReady} bordered={true} img={analysis?.images?.global?.raw?.[subType]} secondaryImg={subType === 'crown' ? analysis?.images?.global?.ml?.[subType] : ''} /></div>}
										<p className='text-center font-normal font-bold text-xl leading-5 tracking-wider' style={{ color: '#707D87' }}>
											{dayjs
												.unix(analysis.created_at)
												.format("MM-DD-YY")}:
											{
												analyses[0].id !== analysis.id && analysis?.images?.global?.hair_growth?.percentage >= 0 ?
													<span className='text-center font-normal font-bold text-2xl leading-5 tracking-tighter opacity-80' style={{ color: '#F6F7FA' }}>
														&nbsp;{calculateGroIndexScore(analysis?.images?.global?.hair_growth?.percentage, 'global')}
													</span>
													: ' N/A'
											}
										</p>
									</div>
								</div>
							);
						}
						return <></>;
					})}
				</div>
				<button
					className="text-2xl focus:outline-none"
					onClick={function () {
						changeAnalysis(history, 'next', analysis_id_int, analyses);
					}}
				>
					<img src={greaterThanIcon} className='w-14 h-14' />
				</button>
			</div>
		</div>
	)
}

export default GlobalImageCompare